var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useRef, useState } from 'react';
import { useCardDragDrop } from 'src/hooks/useCardDragDrop';
import { useFileHandling } from '../../InternalConversation/hooks';
export var useConversationComposer = function (_a) {
    var isDisabled = _a.isDisabled, scrollDependency = _a.scrollDependency;
    var _b = useState(''), text = _b[0], setText = _b[1];
    var _c = useState([]), mentionedAdminUserIds = _c[0], setMentionedAdminUserIds = _c[1];
    var bodyRef = useRef(null);
    var fileHandling = useFileHandling();
    var addFiles = fileHandling.addFiles, clearFiles = fileHandling.clearFiles;
    var dragDrop = useCardDragDrop(addFiles, isDisabled);
    useEffect(function () {
        if (!bodyRef.current)
            return;
        bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    }, [scrollDependency]);
    var resetComposer = function () {
        setText('');
        setMentionedAdminUserIds([]);
        clearFiles();
    };
    return __assign(__assign({ text: text,
        setText: setText,
        mentionedAdminUserIds: mentionedAdminUserIds,
        setMentionedAdminUserIds: setMentionedAdminUserIds,
        bodyRef: bodyRef,
        resetComposer: resetComposer }, fileHandling), dragDrop);
};
